import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [accessCode, setAccessCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await signup(email, password, accessCode);
      toast.success('Compte créé avec succès !');
      navigate('/programme');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de la création du compte');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1543183601-e4c9648a72f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHx6ZW4lMjBuYXR1cmUlMjBjYWxtJTIwc3RvbmVzJTIwd2F0ZXJ8ZW58MHx8fHwxNzcyNTM5NzM1fDA&ixlib=rb-4.1.0&q=85)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="w-full max-w-md bg-white/95 backdrop-blur-md rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] p-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-serif font-light text-sage-700 mb-2" data-testid="signup-title">Déclic RePas</h1>
          <p className="text-sage-700/70 font-sans">Créez votre espace personnel</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-sage-700 font-sans">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="border-sand-200 focus:border-sage-500 focus:ring-sage-500"
              data-testid="signup-email-input"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-sage-700 font-sans">Mot de passe</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              className="border-sand-200 focus:border-sage-500 focus:ring-sage-500"
              data-testid="signup-password-input"
            />
            <p className="text-xs text-sage-700/60">Minimum 6 caractères</p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="accessCode" className="text-sage-700 font-sans">Code d'accès</Label>
            <Input
              id="accessCode"
              type="text"
              value={accessCode}
              onChange={(e) => setAccessCode(e.target.value.toUpperCase())}
              required
              placeholder="DRP-XXXXXX"
              className="border-sand-200 focus:border-sage-500 focus:ring-sage-500 font-mono"
              data-testid="signup-accesscode-input"
            />
            <p className="text-xs text-sage-700/60">Code reçu après votre achat</p>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-sage-500 hover:bg-sage-600 text-white font-sans h-12 rounded-xl"
            data-testid="signup-submit-button"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Création...
              </>
            ) : (
              'Créer mon compte'
            )}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-sage-700/70 font-sans">
            Déjà un compte ?{' '}
            <Link to="/login" className="text-sage-500 hover:text-sage-700 font-medium" data-testid="login-link">
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;